<template>
  <div>
    <template v-if="type === 'default' || type === 'multi-check'">
      <gj-select
          v-on="$listeners"
          v-bind="$attrs"
          :options="options"
          :type="type"
      ></gj-select>
    </template>
    <template v-if="type === 'input'">
      <gj-input
          v-on="$listeners"
          v-bind="$attrs"
      ></gj-input>
    </template>
  </div>
</template>

<script>
import {CONDITION} from "@/utils/condition";

export default {
  name: "form-type",
  props: {
    // 框属于什么类型
    type: {
      type: String,
      default: 'default'
    },
    optionsType:{
      type: String
    }
  },
  computed: {},
  data(){
    return{
      options: CONDITION[this.optionsType] || []
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>
